import { cn } from "@/lib/utils";

/** Concentric globe arcs - the logo's dominant motif. */
export function GlobeArcs({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 400 400"
      fill="none"
      className={cn("text-brand-600", className)}
      aria-hidden
    >
      <circle cx="200" cy="200" r="190" stroke="currentColor" strokeOpacity="0.12" strokeWidth="1.5" />
      <circle cx="200" cy="200" r="140" stroke="currentColor" strokeOpacity="0.14" strokeWidth="1.5" />
      <ellipse cx="200" cy="200" rx="70" ry="190" stroke="currentColor" strokeOpacity="0.1" strokeWidth="1.5" />
      <path d="M10 200h380M40 120h320M40 280h320" stroke="currentColor" strokeOpacity="0.08" strokeWidth="1.5" />
    </svg>
  );
}

